import React from 'react';
import { FlexHeader } from './shared';
import { useHasFF } from 'venn-utils';
import { PanelHeader } from './studio-main-left-panel/panels/components/PanelHeader';
import { cn } from '@/lib/utils';
import { PanelItem } from './studio-right-panel/tabs/sections/components/shared';

interface PanelSectionProps {
  header?: string | JSX.Element;
  children: React.ReactNode;
  className?: string;
}

const Header = ({ children }: { children: string | JSX.Element }) => {
  const hasBlockAssignment = useHasFF('block_assignment_ff');

  return hasBlockAssignment ? (
    <PanelHeader.Root>
      <PanelHeader.Text>{children}</PanelHeader.Text>
    </PanelHeader.Root>
  ) : (
    <FlexHeader>{children}</FlexHeader>
  );
};

export const PanelSection = ({ header, children, className }: PanelSectionProps) => {
  const hasBlockAssignment = useHasFF('block_assignment_ff');

  return (
    <PanelItem className={className}>
      {header && <Header>{header}</Header>}
      <div className={cn(hasBlockAssignment ? 'pt-[12px] px-[10px] pb-[32px]' : 'px-[10px]')}>{children}</div>
    </PanelItem>
  );
};
